import { ofType } from "redux-observable";
import { concat, from, of } from "rxjs";
import { filter, mapTo, switchMap, take } from "rxjs/operators";
import { selectContractMissingResources } from "../../../selectors/selectContractInfo";
import { actionModalOpen } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { TypeActionNotEnoughResource, } from "../../not-enough-resource/actionNotEnoughResource";
import { IdMissingResourceTypes } from "../../not-enough-resource/IdMissingResourceTypes";
import { actionOngoingPurchaseStandardSelect } from "../../ongoing-purchase/actionOngoingPurchase";
import { actionContractFulfill, TypeActionContractInfo, } from "../actionContractInfo";
export var epicMarketContractRequestFulfill = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionContractInfo.RequestFulfill), switchMap(function (action) {
        var missingContractResources = selectContractMissingResources(state$.value, action.contractId);
        if (missingContractResources.length > 0) {
            return concat(from([
                actionOngoingPurchaseStandardSelect([
                    {
                        missingResources: missingContractResources,
                        missingType: IdMissingResourceTypes.Resources,
                    },
                ]),
                actionModalOpen(IdModal.NotEnoughResource),
            ]), action$.pipe(ofType(TypeActionNotEnoughResource.BuyWithGoldComplete), take(1), filter(function (notEnoughResourceAction$) {
                return notEnoughResourceAction$.isPurchased;
            }), mapTo(actionContractFulfill(action.contractId))));
        }
        return of(actionContractFulfill(action.contractId));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/market/epics/epicMarketContractRequestFulfill.ts
// module id = 2000
// module chunks = 3